import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Template } from 'app/mdm/template/services/template';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TemplateService {
  protected baseUrl = `${environment.mdmApi}`;

  constructor(private http: HttpClient) {}

  loadTemplates(type?: string): Observable<Array<Template>> {
    const url = `${this.baseUrl}/templates${!!type ? `?type=${type}` : ''}`;
    return this.http.get(url).pipe(map((resp) => resp as Array<Template>));
  }

  getTemplate(code: string): Observable<Template> {
    const url = `${this.baseUrl}/templates/${code}`;
    return this.http.get(url).pipe(map((resp) => resp as Template));
  }

  saveTemplate(template: Template): Observable<any> {
    if (!template.id) {
      return this.http.post(`${this.baseUrl}/templates`, template);
    } else {
      const url = `${this.baseUrl}/templates/${template.id}`;
      return this.http.put(url, template);
    }
  }
}
